import React, { useEffect } from 'react';
import {
    Box,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Tooltip,
    Button,
    FormControl,
    InputLabel,
    Select,
    Typography,
    Input,
    TextField,
    Tabs,
    Tab
} from '@mui/material';
import { Folder } from 'react-feather';
import { useDropzone } from 'react-dropzone';
import Toast from "../../components/Toast";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import "./PDFUpload.css";
import VidTable from "../instructions/TutorialVidDataGrid";
import VideoUpload from "./VideoUpload";
import VideoCategoriesManager from '../instructions/VideoCategoriesManager';
import Page from '../../components/Page';
import { isWithinUploadLimit, uploadSizeErrorMessage, MAX_UPLOAD_LABEL } from '../../utils/uploadLimits';
import { useTutorialVideos, useUploadVideoUrl } from '../../hooks/useAppResources';
import { useUploadPdfFile } from '../../hooks/useFiles';

function PDFUploadPage(){
    ///// Currently vids either require a youtube Id or a embed version of a youtube link to function /////
    ///// PDF Upload form select relevant pdf type to display it in the correct location on the website /////
    const navigate = useNavigate();
    const company = useSelector((state) => state.CompanyReducer.userCompanies[0]);
    const { acceptedFiles, getRootProps, getInputProps, open } = useDropzone({
        accept: 'application/pdf,.pdf',
        multiple: false,
        disabled: !company,
    });
    const [file, setFile] = React.useState([]);
    const [review, setReview] = React.useState(false);
    const validation = useSelector((state) => state.FileReducer.file);
    const { data: vids = [] } = useTutorialVideos();
    const uploadPdfFile = useUploadPdfFile();
    const uploadVideoUrlMutation = useUploadVideoUrl();
    const [agType, setAgType] = React.useState('');
    const [vidUrl, setVidUrl] = React.useState();
    const [vidType, setVidType] = React.useState('');
    const [vidCat, setVidCat] = React.useState('');
    const [vidCatNumber, setVidCatNumber] = React.useState('');
    const [vidRole, setVidRole] = React.useState('');
    const [vidName, setVidName] = React.useState('');
    const [vidDes, setVidDes] = React.useState('');
    const handleChange = (event) => {
        setAgType(Number(event.target.value));
    };
    const handleChangeVideoType = (event) => {
        setVidType(Number(event.target.value));
    };

    let newVid ={
        VidUrl: vidUrl,
        VidType: Number(vidType),
        VidCategory: vidCat,
        VidOrder: vidCatNumber,
        VidName: vidName,
        VidDescription: vidDes
    }

    React.useEffect(() => {
        if (validation?.file?.length) {
            setReview(true)
        }
        setFile(acceptedFiles);
    },[acceptedFiles, validation.file]);

    const files = acceptedFiles.map(file => (
        <Tooltip key={file.path} title="Click to select different file">
            <ListItem sx={{ border: '1px solid black' }}>
                    <ListItemIcon>
                        <Folder/>
                    </ListItemIcon>
                    <ListItemText>
                        {file.path} - {file.size} bytes
                    </ListItemText>
            </ListItem>
        </Tooltip>
    ));

    function submitVideoUrl(){
        uploadVideoUrlMutation.mutate(newVid);
        setVidType('');
        setVidUrl('');
        setVidCat('')
        setVidCatNumber('');
        setVidRole('');
        setVidName('');
        setVidDes('');
    };

    const handleUpload = () => {
        if (!file.length) return Toast.fire({ title: 'File required', icon: 'error' });
        else if (!isWithinUploadLimit(file[0])) return Toast.fire({ title: uploadSizeErrorMessage(), icon: 'error' });
        else if (!file[0].name.includes('.pdf')) return Toast.fire({ title: '.PDF FILES ONLY', icon: 'error' });
        else if (agType == null) return Toast.fire({ title: 'Please Enter a Categorical Type for this Document.', icon: 'error' });
        else uploadPdfFile.mutate({ file: file[0], name: file[0].name, companyId: company.id, PDFType: agType, setFile, setAgType, navigate })
    };

    const [value, setValue] = React.useState(0);
    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Page title="PDF Upload">
        <Box sx={{margin: "5%"}}>
            <Tabs value={value} onChange={handleTabChange} style={{ borderBottom: '2px solid darkGray', paddingBottom: '10px' }}>
                <Tab label="Video Management" />
                <Tab label="Video Category Management" />
                <Tab label="YouTube Video Upload" />
                <Tab label="PDF Upload" />
            </Tabs>
            {/* Only mount active tab so Data Grid (VidTable) is not in a 0-height hidden container */}
            <Box p={3} role="tabpanel" id="pdf-upload-tabpanel">
            {value === 0 && <VidTable vids={vids}/>}
            {value === 1 && <VideoCategoriesManager/>}
            {value === 2 && <VideoUpload/>}
            {value === 3 && (
                <Box style={{border:'solid black 2px'}}>
                    <h2 style={{margin:'5px'}}>PDF Uploads</h2>
                    <p>{`Select Type of Document to assign it to a location on the site. PDF files only (up to ${MAX_UPLOAD_LABEL}).`}</p>
                    <Typography>License Agreement PDF Upload</Typography>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                        minHeight: 220,
                    }}>
                        <div
                            className="dropzone"
                            style={{
                                width: '80%',
                                minHeight: 180,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderWidth: '2px',
                                borderRadius: '2px',
                                borderStyle: 'dashed',
                                padding: '20px',
                                transition: 'border .24s ease-in-out',
                                boxSizing: 'border-box',
                                cursor: !company ? 'not-allowed' : 'pointer',
                            }}
                            {...getRootProps()}
                        >
                            <input {...getInputProps()} />
                            { acceptedFiles.length > 0 ? (
                                <List>{files}</List>
                            ) : (
                                <>
                                    <p style={{ margin: '0 0 12px 0' }}>Drag 'n' drop .PDF file here, or click to select</p>
                                    <Button variant="outlined" size="small" onClick={(e) => { e.stopPropagation(); open(); }} disabled={!company}>
                                        Select PDF file
                                    </Button>
                                </>
                            ) }
                        </div>
                    </Box>
                    <Box sx={{width:"100%", height:"100%", marginTop: '5%'}}>
                        <Typography>Set PDF Type</Typography>
                        <Box component="form" className="pdf" sx={{ display: 'flex', flexWrap: 'wrap' }}>
                            <FormControl sx={{ m: 2, minWidth: 120 }}>
                                <Select
                                    native
                                    onChange={handleChange}
                                    value={agType}
                                >
                                    <option value={0}>Select type</option>
                                    <option value={1}>Upload Agreement PDF</option>
                                    <option value={2}>Download Agreement PDF</option>
                                </Select>
                            </FormControl>
                        </Box>
                        <Button sx={{ width: '50%', margin: "10px" }}
                            variant="contained"
                            onClick={handleUpload}
                            disabled={!agType}
                        >
                            Upload .PDF
                        </Button>
                    </Box>
                </Box>
            )}
            </Box>
        </Box>
        </Page>
    )
};

export default PDFUploadPage;
